var _style, _polygon, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.gift .st0{fill:url(#SVGID_1_);}\n\t.gift .st1{fill:url(#SVGID_00000156566383373522334150000008315901486958929306_);}\n\t.gift .st2{fill:url(#SVGID_00000017484091076553609590000014817910113531805585_);}\n\t.gift .st3{fill:none;}\n\t.gift .st4{fill:#FFFFFF;}\n\t.gift .st5{fill:#CECECE;}\n\t.gift .st6{fill:url(#SVGID_00000129926342667089594200000003604332422853195664_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "gift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.6425,
    y1: 14.9515,
    x2: 15.5278,
    y2: 28.8368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.94,12.65 4.02,30.91 6.51,31.03 13.18,31.18 12.92,14.4 12.92,12.65  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112605594757699908040000001833359330058620594_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9692,
    y1: 5.573,
    x2: 27.9058,
    y2: 13.5096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112605594757699908040000001833359330058620594_)"
    },
    d: "M29.02,7.17H18.37v2.37v2.37h10.65 c0.65,0,1.18-0.53,1.18-1.18V9.54V8.36C30.2,7.7,29.67,7.17,29.02,7.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017495409755507122700000000778301291633439625_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2777,
    y1: 5.9456,
    x2: 11.5697,
    y2: 13.2375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017495409755507122700000000778301291633439625_)"
    },
    d: "M4.43,7.25H3.38 c-0.58,0-1.05,0.52-1.05,1.17v2.34c0,0.65,0.47,1.17,1.05,1.17h9.49V9.59V7.25H4.43z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.42,
    y: 7.06,
    className: "st3",
    width: 4.96,
    height: 2.48
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.25,5.05h3.93c-0.86-1.96-2.81-3.29-5.02-3.29h-1.1c-0.39,0-0.76,0.11-1.08,0.29 C8.1,3.74,9.52,5.07,11.25,5.05z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.14,5.03h3.44c0.18-0.32,0.29-0.69,0.29-1.08c0-1.19-0.97-2.16-2.16-2.16h-1.08 c-0.94,0-1.83,0.25-2.61,0.68c-0.02,0.13-0.04,0.26-0.04,0.39C18.97,4.06,19.94,5.03,21.14,5.03z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.22,15.36l0.2-1.36l-0.22,0v-1.12H13.6v1.06l-0.03,0l-0.01,17.03l4.95,0.03l-0.22-10.98 c0-0.51-0.11-0.67,0.41-0.67l0-2.35C18.57,16.33,19.87,13.21,18.22,15.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.42,
    y: 7.16,
    className: "st5",
    width: 4.96,
    height: 4.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.18,5.05h-3.93c-1.73,0.02-3.15-1.31-3.28-3C7.31,2.42,6.86,3.13,6.86,3.95c0,1.21,0.94,2.33,2.16,2.33 h6.47C15.41,5.9,15.33,5.4,15.18,5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.14,5.03c-1.2,0-2.17-0.98-2.16-2.17c0-0.13,0.04-0.44,0.07-0.57c-1.35,0.75-2.43,2.4-2.76,3.99h6.33 c0.8,0,1.59-0.61,1.96-1.25H21.14z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158011648528950587810000007514488738325529778_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.6543,
    y1: 15.0388,
    x2: 30.2792,
    y2: 28.6636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158011648528950587810000007514488738325529778_)"
    },
    d: "M19.23,12.46v1v2c0,0.55-0.29,1-0.84,1 v2.97c0.55,0,0.75,0.49,0.75,1.04l-0.01,10.36l9.03-0.05l-0.51-17.66l-0.28-0.66H19.23z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.25,5.56h5.17c0.57,0,1.1-0.31,1.39-0.81c0.14-0.25,0.22-0.52,0.22-0.8c0-0.89-0.72-1.61-1.61-1.61 h-0.93c-0.74,0-1.48,0.19-2.13,0.55C18.32,3.47,17.56,4.43,17.25,5.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.11,8.61v1.86c0,0.37,0.3,0.68,0.68,0.68h8.13V7.93H3.79C3.42,7.93,3.11,8.24,3.11,8.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.77,3.95c0,0.89,0.72,1.61,1.61,1.61h5.17c-0.06-0.19-0.12-0.38-0.21-0.58c-0.7-1.6-2.28-2.64-4.03-2.64 H9.38c-0.28,0-0.55,0.07-0.8,0.21C8.08,2.84,7.77,3.38,7.77,3.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.69,17.25c-0.65,0-1.19-0.53-1.19-1.19v-2.54h-3.22V29.9h3.22V19.79c0-0.65,0.53-1.19,1.19-1.19 c0.65,0,1.19,0.53,1.19,1.19V29.9h6.94V13.52h-6.94v2.54C19.88,16.72,19.35,17.25,18.69,17.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.98,
    y: 13.52,
    className: "st3",
    width: 6.94,
    height: 16.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.01,7.93h-8.13v3.22h8.13c0.37,0,0.68-0.3,0.68-0.68V8.61C28.69,8.24,28.38,7.93,28.01,7.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.61,
    y: 13.16,
    className: "st3",
    width: 7.68,
    height: 17.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.75,8.61v1.86c0,0.58,0.47,1.04,1.04,1.04h8.5V7.57h-8.5C3.21,7.57,2.75,8.03,2.75,8.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.13,4.94c0.17-0.3,0.27-0.64,0.27-0.99c0-1.09-0.89-1.98-1.98-1.98h-0.93c-0.8,0-1.6,0.21-2.31,0.6 c-1.22,0.68-2.09,1.85-2.37,3.22l-0.03,0.13h5.63C23.12,5.93,23.78,5.55,24.13,4.94z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.92,
    y: 7.57,
    className: "st3",
    width: 3.95,
    height: 3.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.74,16.88c-0.46,0-0.83-0.37-0.83-0.82v-2.91h-3.99v17.11h3.99V19.79c0-0.45,0.37-0.82,0.83-0.82 c0.46,0,0.83,0.37,0.83,0.82v10.48h7.75V13.16h-7.75v2.91C19.57,16.51,19.2,16.88,18.74,16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.4,3.95c0,1.09,0.89,1.98,1.98,1.98h5.63l-0.03-0.14c-0.07-0.32-0.17-0.64-0.31-0.95 c-0.76-1.74-2.47-2.86-4.37-2.86H9.38c-0.34,0-0.68,0.09-0.98,0.26l0,0C7.79,2.59,7.4,3.24,7.4,3.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.01,7.57h-8.5v3.95h8.5c0.58,0,1.04-0.47,1.04-1.04V8.61C29.05,8.03,28.59,7.57,28.01,7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.01,6.21h-3.08l0.36-0.6c0.3-0.5,0.46-1.08,0.46-1.66c0-1.84-1.49-3.33-3.33-3.33h-0.93c-2.14,0-4.15,1.15-5.25,2.99 L15.9,4.18l-0.34-0.57c-1.1-1.84-3.11-2.98-5.25-2.99H9.38c-1.84,0-3.33,1.49-3.33,3.33c0,0.58,0.16,1.16,0.46,1.66l0.36,0.6 H3.79c-1.32,0-2.4,1.08-2.4,2.4v1.86c0,1.01,0.65,1.91,1.6,2.25l0.26,0.09v18.17l0.01,0.11c0.01,0.29,0.24,0.52,0.53,0.52h24.23 c0.3,0,0.54-0.24,0.54-0.54c0-0.03,0-0.06-0.01-0.1l-0.01-0.06l0-18.11l0.26-0.09c0.95-0.34,1.6-1.24,1.6-2.25V8.61 C30.41,7.29,29.33,6.21,28.01,6.21z M16.54,5.74c0.3-1.45,1.21-2.69,2.51-3.41c0.75-0.41,1.59-0.63,2.45-0.64h0.93 c1.25,0,2.26,1.01,2.26,2.26c0,0.4-0.11,0.79-0.3,1.13c-0.4,0.7-1.15,1.13-1.95,1.13h-5.98L16.54,5.74z M18.16,7.28v4.52h-4.52 V7.28H18.16z M8.26,1.99c0.34-0.19,0.73-0.3,1.12-0.3h0.93c2.01,0,3.82,1.19,4.63,3.03c0.15,0.34,0.26,0.68,0.33,1.01l0.1,0.47 H9.38c-1.25,0-2.26-1.01-2.26-2.26C7.12,3.14,7.56,2.39,8.26,1.99z M12.57,30.55H4.33V12.87h8.24V30.55z M12.57,11.8H3.79 c-0.73,0-1.33-0.6-1.33-1.33V8.61c0-0.73,0.6-1.33,1.33-1.33h8.78V11.8z M27.6,30.55h-8.32V19.79c0-0.3-0.24-0.54-0.54-0.54 c-0.3,0-0.54,0.24-0.54,0.54v10.76h-4.56V12.87h4.56v3.19c0,0.3,0.24,0.54,0.54,0.54c0.3,0,0.54-0.24,0.54-0.54v-3.19h8.32 V30.55z M29.34,10.47c0,0.73-0.6,1.33-1.33,1.33h-8.78V7.28h8.78c0.73,0,1.33,0.6,1.33,1.33V10.47z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.771813928660218fc680532d8e603428.svg";
export { ForwardRef as ReactComponent };